import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

/**
 * Hook to prompt the user with a confirmation message when navigating away
 * if `when` is true, using React Router v6.
 *
 * @param when Whether to block navigation
 * @param message Message to display in the confirmation dialog
 */

export function usePrompt(when: boolean, message: string) {
  const blocker = useBlocker(when);

  useEffect(() => {
    if (!blocker || blocker.state !== 'blocked') {
      return;
    }

    const proceed = window.confirm(message);

    if (proceed) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker, message]);
}
